<template>
  <aside class="admin-sidebar">
    <div class="logo">Admin Panel</div>

    <router-link to="/admin/dashboard" class="nav-item">Dashboard</router-link>
    <router-link to="/admin/tenants" class="nav-item">Tenants</router-link>
    <router-link to="/admin/users" class="nav-item">Users</router-link>
    <router-link to="/admin/flows" class="nav-item">Flows</router-link>
    <router-link to="/admin/profile" class="nav-item">Profile</router-link>
  </aside>
</template>

<style scoped>
.admin-sidebar {
  width: 240px;
  min-height: 100vh;
  background: #111827;
  color: #fff;
  padding: 20px 16px;
}
.logo {
  font-size: 20px;
  font-weight: 800;
  margin-bottom: 20px;
}
.nav-item {
  display: block;
  color: #d1d5db;
  text-decoration: none;
  padding: 10px 12px;
  border-radius: 10px;
  margin-bottom: 8px;
}
.nav-item.router-link-active {
  background: #8b5cf6;
  color: #fff;
}
</style>
